











import { Vue, Component, Prop } from 'vue-property-decorator';
import { ExamItem } from '@/app/exam/ui/exam-dashboard-types';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import i18n from "@/plugins/i18n";

@Component
export default class DashboardFinalExamButtonComponent extends Vue {
  @Prop()
  public finalExamResult: ExamItem;

  @Prop({
    required: true
  })
  public buttonCaption: string;

  public onButtonClicked(): void {
    const location = getPageLocationByHref(this.finalExamResult.href as string);
    this.$router.push(location);
  }
}
